<template>
  <div>
    <PageHeader :title="title">
      <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-2">
        <SecondaryButton @click="openExportModal = true" class="w-full sm:w-auto">Exporter</SecondaryButton>
        <SecondaryButton
          v-if="storeRetributionPaymentMethodEstalyGiftCard(store)"
          @click="openRetributionPaymentMethodModal = true"
          class="w-full sm:w-auto"
        >
          🎁 Comment les primes sont-elles versées ?
        </SecondaryButton>
      </div>
    </PageHeader>

    <div class="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <SearchSelector
        class="w-full md:w-96"
        v-if="storeOptions.length > 1"
        id="store"
        label="Magasin"
        name="store"
        required
        v-model="currentStoreId"
        :options="storeOptions"
        :search-keyword-threshold="0"
        search-placeholder="Rechercher un magasin"
      />
      <div class="w-full md:w-96">
        <p class="mb-2 block text-sm leading-6 text-gray-900 font-bold">Période</p>
        <MonthSelector v-model="monthValue" />
      </div>
    </div>

    <EstalyGiftCardModal :open="openRetributionPaymentMethodModal" @close="openRetributionPaymentMethodModal = false" />
    <ExportRetributionsModal :open="openExportModal" @close="openExportModal = false" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { SearchSelector, MonthSelector, PageHeader, SecondaryButton } from "@estaly/ui";
import EstalyGiftCardModal from "@/components/retribution/EstalyGiftCardModal.vue";
import ExportRetributionsModal from "@/components/retribution/ExportRetributionsModal.vue";

export default {
  components: {
    SearchSelector,
    MonthSelector,
    PageHeader,
    SecondaryButton,
    EstalyGiftCardModal,
    ExportRetributionsModal,
  },

  data() {
    return {
      openRetributionPaymentMethodModal: false,
      openExportModal: false,
    };
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    selectedMonth: {
      type: Date,
      required: true,
    },
  },
  emits: ["update:selectedMonth"],

  created() {
    this.currentStoreId = this.$route.query.storeId || this.selectedStoreId || this.filteredStores[0]?.id;
  },

  computed: {
    ...mapState("store", { stores: "index" }),
    ...mapState("retributionConfigurations", ["selectedStoreId"]),
    ...mapGetters("store", ["storeRetributionPaymentMethodEstalyGiftCard", "activeOfflineStores"]),

    currentStoreId: {
      get() {
        return this.selectedStoreId;
      },
      async set(value) {
        this.setSelectedStoreId(value);

        const url = new URL(location);
        url.searchParams.set("storeId", value);
        history.pushState({}, "", url);
      },
    },

    filteredStores() {
      return this.activeOfflineStores;
    },

    storeOptions() {
      return this.filteredStores.map((store) => ({
        label: store.salesChannel,
        value: store.id,
      }));
    },

    store() {
      return this.stores.find((store) => store.id === this.selectedStoreId);
    },
    monthValue: {
      get() {
        return this.selectedMonth;
      },
      set(value) {
        this.$emit("update:selectedMonth", value);
      },
    },
  },

  methods: {
    ...mapMutations("retributionConfigurations", ["setSelectedStoreId"]),
  },
};
</script>
